import { Component, OnInit } from '@angular/core';

interface ApplicationStats {
  submitted: number;
  active: number;
  interviews: number;
  accepted: number;
  rejected: number;
  saved: number;
}

interface Interview {
  id: string;
  position: string;
  company: string;
  type: string;
  date: string;
  time: string;
  icon: string;
  joinLabel: string;
}

interface CareerTool {
  id: string;
  icon: string;
  title: string;
  description: string;
  actionLabel: string;
  actionColor: string;
  badgeLabel: string;
}

interface JobMatch {
  id: string;
  title: string;
  company: string;
  location: string;
  matchPercentage: number;
  salary: string;
  badge: string;
}

interface SnapshotStat {
  value: string;
  label: string;
}

interface GeneratedDocument {
  id: string;
  name: string;
  date: string;
  icon: string;
}

@Component({
  selector: 'app-profile-overview',
  templateUrl: './profile-overview.component.html',
  styleUrls: ['./profile-overview.component.css'],
})
export class ProfileOverviewComponent implements OnInit {
  stats: ApplicationStats = {
    submitted: 42,
    active: 12,
    interviews: 3,
    accepted: 0,
    rejected: 8,
    saved: 15,
  };

  profileStrength: number = 78;

  interviews: Interview[] = [
    {
      id: '1',
      position: 'Senior Product Designer',
      company: 'TechFlow Inc.',
      type: 'Technical Interview',
      date: 'Today at 2:30 PM',
      time: 'Oct 15, 2024',
      icon: '📋',
      joinLabel: 'profileOverview.join',
    },
    {
      id: '2',
      position: 'Lead UX Designer',
      company: 'Creative Studio',
      type: 'Culture Fit - 1 on 1',
      date: 'Scheduled soon',
      time: 'Oct 18, 2024',
      icon: '💼',
      joinLabel: 'profileOverview.join',
    },
  ];

  careerTools: CareerTool[] = [
    {
      id: '1',
      icon: 'bi bi-file-earmark-text',
      title: 'profileOverview.toolCvEval',
      description: 'profileOverview.toolCvEvalDesc',
      actionLabel: 'profileOverview.review',
      actionColor: 'secondary',
      badgeLabel: 'profileOverview.score85',
    },
    {
      id: '2',
      icon: 'bi bi-stars',
      title: 'profileOverview.toolCvCreate',
      description: 'profileOverview.toolCvCreateDesc',
      actionLabel: 'profileOverview.continue',
      actionColor: 'primary',
      badgeLabel: 'profileOverview.draftSaved',
    },
    {
      id: '3',
      icon: 'bi bi-mic-fill',
      title: 'profileOverview.toolInterviewPrep',
      description: 'profileOverview.toolInterviewPrepDesc',
      actionLabel: 'profileOverview.startPractice',
      actionColor: 'info',
      badgeLabel: '',
    },
  ];

  jobMatches: JobMatch[] = [
    {
      id: '1',
      title: 'Software Engineer',
      company: 'Microsoft',
      location: 'Seattle, WA',
      matchPercentage: 92,
      salary: '$150K - $180K',
      badge: 'ACTIVE - $150K',
    },
    {
      id: '2',
      title: 'Product Manager',
      company: 'Acme',
      location: 'San Francisco, CA',
      matchPercentage: 88,
      salary: '$160K - $200K',
      badge: 'ACTIVE - $180K',
    },
  ];

  snapshotStats: SnapshotStat[] = [
    {
      value: '8+',
      label: 'profileOverview.reviews',
    },
    {
      value: '15+',
      label: 'profileOverview.resources',
    },
  ];

  generatedDocuments: GeneratedDocument[] = [
    {
      id: '1',
      name: 'Ahmed_CV_2024.pdf',
      date: 'Uploaded 2 days ago',
      icon: '📄',
    },
    {
      id: '2',
      name: 'Ahmed_CV_2024.pdf',
      date: 'Uploaded 3 days ago',
      icon: '📄',
    },
  ];

  constructor() {}

  ngOnInit(): void {}

  onJoinInterview(interview: Interview): void {
    console.log('Joining interview:', interview);
  }

  onGenerateProfile(): void {
    console.log('Generating complete profile');
  }

  onViewDetails(jobMatch: JobMatch): void {
    console.log('View details for:', jobMatch);
  }

  onGenerateCoverLetter(): void {
    console.log('Generating cover letter');
  }

  onViewCalendar(): void {
    console.log('Viewing calendar');
  }
}
